import { useVODStore } from '@/shared/store'
import { getErrorMessage } from '@/shared/lib'
import { useCallback, useState } from 'react'
import { useVODService } from '@/app/context/DIContext/DIServices'
import VodDetails from '@/features/VOD/vodClasses/vodDetails'
import { IVODServiceStreamIQ } from '@/shared/types/services/types/vodService/IVodServiceStreamIQ'

import { mapToVodDetails } from '@/clients/streamiq/shared/lib'

const useItemDetailsStreamIQ = () => {
    const [details, setDetails] = useState<VodDetails | null>(null)
    const [error, setError] = useState<unknown>()
    const vodCachedDetails = useVODStore((state) => state.vodCachedDetails)
    const setVodCachedDetails = useVODStore(
        (state) => state.setVodCachedDetails
    )
    const { fetchVodItemDetails } = useVODService() as IVODServiceStreamIQ

    const getItemDetails = useCallback(
        async (
            item: {
                productId: string | null
                assetType: string | undefined
                id: string
                serviceName?: string
            },
            isForceFetchDetails = false
        ) => {
            setDetails(null)
            const { productId, assetType, id, serviceName } = item

            if (!productId || !assetType || !serviceName) return

            const cachedItem = vodCachedDetails.find(
                (element) => element.vodItemId === id
            )
            if (cachedItem && !isForceFetchDetails) {
                setDetails(cachedItem.details)
                return
            }

            try {
                const details = await fetchVodItemDetails(
                    productId,
                    assetType,
                    serviceName
                )

                console.log('herer', details)

                if (details) {
                    const vodItemDetails = mapToVodDetails(details)
                    setDetails(vodItemDetails)
                    setVodCachedDetails(id, vodItemDetails)
                }
            } catch (error) {
                getErrorMessage('useItemDetails', error)
                setError(error)
            }
            return () => setDetails(null)
        },
        [vodCachedDetails, setVodCachedDetails]
    )

    return { details, getItemDetails, error }
}

export default useItemDetailsStreamIQ
